export default {
    state: {
        0: 'New',
        1: 'Valid, no imported yet',
        2: 'Import running',
        3: 'Import successfully completed',
        4: 'Import incorrect',
        5: 'Data invalid, no import possible'
    }
}
